export const CATEGORY_KEYS = [
  'MOBILITY_OUTDOOR', 'HEALTH_WELLNESS', 'ENTERTAINMENT_GASTRO',
  'HARDWARE_FITNESS', 'ECO_NATURE', 'TECH_EDUCATION',
  'CRAFTING_REPAIR', 'FOOD_GROCERIES', 'LOGISTICS_RETAIL',
  'SOCIAL_COMMUNITY',
];

// Accept category values returned by an API instance that has not yet run the data migration.
const PREVIOUS_CATEGORY_KEYS = {
  ERKUNDUNG: 'MOBILITY_OUTDOOR',
  SOZIAL: 'SOCIAL_COMMUNITY',
  SECURITY_SERVICES: 'SOCIAL_COMMUNITY',
  UMWELT: 'ECO_NATURE',
  HANDWERK: 'CRAFTING_REPAIR',
  GESUNDHEIT: 'HEALTH_WELLNESS',
  BILDUNG: 'TECH_EDUCATION',
  KULTUR: 'ENTERTAINMENT_GASTRO',
};

export function canonicalCategoryKey(value) {
  const key = String(value || '').trim().toUpperCase();
  return PREVIOUS_CATEGORY_KEYS[key] || key;
}

export function normalizeCategoryProgresses(progresses = []) {
  const categories = new Map(CATEGORY_KEYS.map(category => [category, {
    category, experiencePoints: 0, level: 1, progressPercentage: 0,
  }]));

  for (const progress of progresses || []) {
    const key = canonicalCategoryKey(progress.category || progress.categoryKey || progress.key);
    const current = categories.get(key);
    if (!current) continue;

    current.experiencePoints += Math.max(0, Number(progress.experiencePoints ?? progress.xp ?? 0) || 0);
    current.level = Math.max(current.level, Number(progress.level) || 1);
    current.level = Math.max(current.level, Math.min(100, Math.floor(Math.sqrt(current.experiencePoints / 50))));
    current.progressPercentage = current.experiencePoints % 100;
  }

  return [...categories.values()];
}
